import { parseFieldBoundaries } from 'boundaries/homesteadParser';
import { setFieldBoundariesByFieldUuid } from 'boundaries';
import { setFieldAreaByFieldUuid } from 'fields';

export const processFieldBoundariesByFieldUuid = ({ dispatch, fieldUuid, rawBoundaries }) => {
  const boundaries = parseFieldBoundaries(rawBoundaries);
  if (!boundaries) {
    return Promise.reject('boundaries response was empty');
  }
  dispatch(setFieldBoundariesByFieldUuid({fieldUuid, boundaries}));
  // Necessary to set area here for fields from shared operations, and it doesn't hurt to
  // redundantly set it for the other fields.
  dispatch(setFieldAreaByFieldUuid({fieldUuid, area:boundaries.area}));
  return Promise.resolve(boundaries);
};
